import { jsxs as o, jsx as r } from "react/jsx-runtime";
import c from "../../../../elements/link-wrapper/link-wrapper.js";
import e from "./desktop-header.module.less.js";
import { useState as v, useEffect as b } from "react";
import { DesktopMenuModal as g } from "../desktop-menu-modal/desktop-menu-modal.js";
import w from "../desktop-menu-modal-content/desktop-menu-modal-content.js";
import A from "../../../../../events/event-aggregator.js";
import { isArrayWithItems as u } from "../../../../../helpers/array-helper.js";
import "dayjs";
import { useTranslation as k } from "react-i18next";
const D = ({ logoUrl: h, menuItems: i, featureLinks: m, isFullscreenPage: f }) => {
  const [s, a] = v(null), t = typeof s == "number" && i[s] ? i[s] : null;
  b(() => {
    const l = A.subscribe("onRouteUpdate", () => {
      a(null);
    });
    return () => {
      l.remove();
    };
  }, []);
  const N = (l) => {
    a(l === s ? null : l);
  }, { t: p } = k();
  return /* @__PURE__ */ o(
    "nav",
    {
      id: "desktop-nav",
      "aria-label": p("HEADER_MENU_ARIA_LABEL"),
      className: ["max-width-as-width padded-sides", e.wrapper, f ? e.fullscreen : ""].join(
        " "
      ),
      children: [
        /* @__PURE__ */ r(c, { ariaLabel: p("HEADER_LOGO_LINK_ARIA_LABEL"), className: e.logoWrapper, url: "/", children: /* @__PURE__ */ r("img", { src: h, alt: "Preem logo", className: e.logo }) }),
        /* @__PURE__ */ o("div", { className: e.innerWrapper, children: [
          /* @__PURE__ */ r("div", { className: e.menuItemsWrapper, children: i.map((l, n) => {
            const d = s === n;
            return u(l.links) ? /* @__PURE__ */ o("div", { className: e.menuButtonWrapper, children: [
              /* @__PURE__ */ o(
                "button",
                {
                  className: e.menuButton,
                  onClick: () => {
                    N(n);
                  },
                  children: [
                    /* @__PURE__ */ r("div", { className: "body-s bold mb-0", children: l.title }),
                    /* @__PURE__ */ r(
                      "span",
                      {
                        className: [e.icon, d ? "ui-icon-arrow-drop-up" : "ui-icon-arrow-drop-down"].join(
                          " "
                        )
                      }
                    )
                  ]
                },
                n
              ),
              d && /* @__PURE__ */ r(
                g,
                {
                  isOpen: !0,
                  close: {
                    function: () => a(null)
                  },
                  title: t?.title ?? "",
                  children: t && /* @__PURE__ */ r(w, { links: t.links })
                }
              )
            ] }, n) : l.url ? /* @__PURE__ */ r(
              c,
              {
                className: `${e.menuButton} ${e.withoutIcon} ${e.menuLink}`,
                url: l.url,
                children: /* @__PURE__ */ r("div", { className: "body-s bold mb-0", children: l.title })
              },
              n
            ) : null;
          }) }),
          u(m) && /* @__PURE__ */ o("ul", { className: e.featureLinksWrapper, children: [
            /* @__PURE__ */ r("div", { className: e.triangle, children: /* @__PURE__ */ r("svg", { xmlns: "http://www.w3.org/2000/svg", width: "78", height: "64", fill: "none", viewBox: "0 0 78 64", children: /* @__PURE__ */ r("path", { d: "M77.563 64H78V0H0c23.664 22.878 49.66 44.163 77.563 64Z" }) }) }),
            m.map((l, n) => /* @__PURE__ */ r("li", { children: /* @__PURE__ */ o(c, { className: `${e.featureLink} body-s mb-0 dynamicIcons`, url: l.url, children: [
              /* @__PURE__ */ r("span", { className: `${e.icon} ${l.icon} default` }),
              /* @__PURE__ */ r("span", { className: `${e.icon} ${l.icon + "-filled"} hover currentPage` }),
              /* @__PURE__ */ r("span", { className: e.innerLink, children: l.title })
            ] }) }, n))
          ] })
        ] })
      ]
    }
  );
};
export {
  D as default
};
